import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	expiration: undefined,
	siteId: undefined,
	customerId: undefined,
	customerIp: undefined,
	ipLocation: undefined,
	sessionId: undefined,
	userBalance: {
		isLoading: false,
		hasBeenLoaded: false,
		error: undefined,
		data: {}
	}
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authUserBalance: (state) => {
			state.userBalance.isLoading = true;
		},
		authUserBalanceCompleted: (state, action) => {
			state.userBalance.isLoading = false;
			state.userBalance.hasBeenLoaded = true;
			state.userBalance.data = action.payload;
		},
		authUserBalanceFailed: (state, action) => {
			state.userBalance.isLoading = false;
			state.userBalance.error = action.payload;
		},
		resetTokenValue: (state) => {
			return initialState;
		},
		setTokenValues: (state, action) => {
			state.expiration = action.payload.exp;
			state.siteId = parseInt(action.payload.site_id);
			state.customerId = parseInt(action.payload.cust_id);
			state.sessionId = action.payload.session_id;
			state.ipLocation = action.payload.cust_ip_address;
			state.customerIp = action.payload.cust_ip_address.split('/')[4];
		}
	}
});

export const {
	authUserBalance,
	authUserBalanceCompleted,
	authUserBalanceFailed,
	setTokenValues,
	resetTokenValue
} = authSlice.actions;

export default authSlice.reducer;
